import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.731 21.012v-2.394C8.482 18.39 7.19 16.547 7 14.248h2.356c.152 1.235.57 2.28 2.375 2.508v-4.275c-2.812-.475-4.275-1.501-4.275-3.914 0-2.109 1.691-3.686 4.275-3.857V3h1.273v1.729c2.451.228 3.971 1.501 4.199 3.857h-2.242c-.209-1.159-.798-1.824-1.957-2.014v3.895c2.812.456 4.446 1.406 4.446 3.971 0 2.223-1.653 3.99-4.446 4.18v2.394zm3.382-6.346c0-1.083-.456-1.615-2.109-1.976v4.066c1.273-.171 2.109-.969 2.109-2.09M9.698 8.358c0 .988.361 1.558 2.033 1.9V6.515c-1.311.152-2.033.893-2.033 1.843"
    }, null, -1)
  ])))
}
export default { render: render }